<template>
    <section class="lymphomap_main g_notification_main">
        <div class="row align-items-center">
            <div class="col-sm">
                <h2 class="main_heading">
                    <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>Notifications
                </h2>
            </div>
        </div>
        <div class="g_notification_main_body pt-2 pt-md-5">
            <div class="g_notification_boxes">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="card" @click="infoPopupOpenMethod('announcements')">
                            <span class="card-icon">
                                <i class="fa fa-bullhorn" aria-hidden="true"></i>
                            </span>
                            <h3 class="card-title">
                                Announcements
                                <label class="badge badge-success" v-if="notificationBadgeInfo && notificationBadgeInfo.count.announcement > 0">{{ notificationBadgeInfo.count.announcement }}</label>
                            </h3>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="card" @click="infoPopupOpenMethod('connections')">
                            <span class="card-icon">
                                <i class="fa fa-users" aria-hidden="true"></i>
                            </span>
                            <h3 class="card-title">
                                Connections
                                <label class="badge badge-success" v-if="notificationBadgeInfo && notificationBadgeInfo.count.connection_request > 0">{{ notificationBadgeInfo.count.connection_request }}</label>
                            </h3>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="card" @click="infoPopupOpenMethod('reminders')">
                            <span class="card-icon">
                                <i class="fa fa-bell-o" aria-hidden="true"></i>
                            </span>
                            <h3 class="card-title">
                                Reminders
                                <label class="badge badge-success" v-if="notificationBadgeInfo && notificationBadgeInfo.count.reminders > 0">{{ notificationBadgeInfo.count.reminders }}</label>
                            </h3>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <router-link :to="{name:'botTickets'}">
                            <div class="card">
                                <span class="card-icon">
                                    <i class="fa fa-ticket" aria-hidden="true"></i>
                                </span>
                                <h3 class="card-title">
                                    Tickets
                                </h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <info-popup v-if="infoPopupState" :name="tabName"></info-popup>
    </section>
</template>

<script>
/*eslint-disable */
import infoPopup from './infoPopup';
import { bus } from '@/main';
import { mapGetters } from 'vuex';

export default {
    name: 'notifications',
    components: {
        'info-popup': infoPopup
    },
    data() {
        return {
            infoPopupState: false,
            tabName: null,
            notificationBadgeInfo: null,
        }
    },
    computed: {
        ...mapGetters([
            'getGlobalNotificationGetters'
        ]),
        getReqNotificationCountMethod() {
            // FIX: Removed optional chaining (?.) for compatibility
            const notificationData = this.$store.getters.getGlobalNotificationGetters;
            return notificationData ? notificationData.data : null;
        }
    },
    mounted() {
        bus.$emit('clearNotificationBadgeInfo', null);
        bus.$on('infoPopupStateBus', (data) => {
            this.infoPopupState = data;
            this.tabName = null;
        });
    },
    methods: {
        infoPopupOpenMethod(name) {
            this.infoPopupState = true;
            this.tabName = name;
        }
    },
    watch: {
        getReqNotificationCountMethod: {
            handler(newVal) {
                if (newVal) {
                    // Check if data is nested in .result or is direct
                    this.notificationBadgeInfo = newVal.result !== undefined ? newVal.result : newVal;
                }
            },
            immediate: true // FIX: Ensures this runs immediately on load
        }
    },
}
</script>

<style lang="scss" scoped>
.g_notification_main {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

    .main_heading {
        color: #ffffff;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .g_notification_boxes {
        .card {
            padding: 0px 15px;
            border-radius: 20px;
            border: 1px solid rgba(123, 134, 138, 0.5);
            background: -webkit-gradient(linear, left top, left bottom, from(rgba(51, 51, 51, 0.6)), to(rgba(0, 0, 0, 0.75)));
            background: linear-gradient(180deg, rgba(51, 51, 51, 0.6), rgba(0, 0, 0, 0.75));
            margin: 15px 0;
            transition: all .3s ease;
            -webkit-transition: all .3s ease;
            -moz-transition: all ease .3s;
            transform: scale(1);
            -moz-transform: scale(1);
            cursor: pointer;
            transform-origin: center center;
            height: 175px;
            align-items: center;
            display: flex;
            justify-content: center;

            .card-title {
                color: #ffe400;
                font-size: 24px;
                font-weight: normal;
                margin: 0px;
            }

            .card-icon .fa {
                font-size: 40px;
                color: #ffe400;
                margin-bottom: 15px;
            }

            &:hover {
                transform: scale(1.06);
                -webkit-transform: scale(1.06);
                -moz-transform: scale(1.06);
                border: 1px solid #769db4;
                background: rgba(144, 209, 249, 0.3);
            }
        }
    }
}
</style>